import { render } from "./AppInfoDialog.vue?vue&type=template&id=b0886414"
import script from "./AppInfoDialog.vue?vue&type=script&lang=js"
export * from "./AppInfoDialog.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ser-kso/new-claim-form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__